<template>
  <div>
    <div class="box box-primary">
      <div class="box-header with-border">
        <h3 class="box-title" style="text-transform: capitalize;" >{{$t('apartment.reservations.info')}}</h3>
      </div>
      <div class="box-body">
        <div class="row">
          <div>
            <div class="col-xs-12">
              <div class="col-xs-12">
                <h2 class="page-header">
                  <i class="fa fa-home"></i> <strong>{{apartment_code}}</strong>
                  <small class="pull-right" style="font-size:14px;">{{$t('apartment.reservations.reservation_code')}}: {{booking_code}}</small>
                </h2>
              </div>
            </div>
            <div class="col-xs-12">
              <div class="col-xs-4">
                <small class="small-title">{{$t('apartment.reservations.checkin_datetime')}}</small>
                <strong style="margin-right:5px;">{{checkin_datetime}}</strong> | <strong style="margin-left:5px;">06:00 am</strong>
              </div>
              <div class="col-xs-4">
                <small class="small-title">{{$t('apartment.reservations.checkout_datetime')}}</small>
                <strong style="margin-right:5px;">{{checkout_datetime}}</strong> | <strong style="margin-left:5px;">22:00 pm</strong>
              </div>
              <div class="col-xs-4">
                <small class="small-title">Số Ngày</small>
                <strong>{{duration}} {{$t('common.day')}}</strong>
              </div>
              <div class="col-xs-12">
                <hr>
              </div>
            </div>
          </div>
          <div>
            <div class="col-xs-12">
              <div class="col-xs-12">
                <h2 class="page-header">
                  <i class="fa fa-users"></i> <strong>{{$t('apartment.reservations.staydetails')}}</strong>
                </h2>
              </div>
            </div>
            <div class="col-xs-12 no-padding">
              <div class="col-xs-7 no-padding">
                <div class="col-xs-12">
                  <div class="col-xs-6">
                    <small class="small-title">{{$t('apartment.reservations.customer_name')}}</small>
                  </div>
                  <div class="col-xs-6">
                    <small class="small-title">{{$t('apartment.reservations.customer_type')}}</small>
                  </div>
                </div>
                <div class="col-xs-12">
                  <div class="col-xs-6">
                    <div>{{customer_full_name}}</div>
                  </div>
                  <div class="col-xs-6">
                    <div>{{dob != null && dob != '' ? (age > 18 ? $t('apartment.reservations.adults') : $t('apartment.reservations.children')) : $t('apartment.reservations.adults')}}</div>
                  </div>
                </div>
              </div>
              <div class="col-xs-5" style="border-left:1px solid;">
                <div class="col-xs-12">
                  <small class="small-title">{{$t('apartment.reservations.room')}}</small>
                  <div v-if="!!count_room">{{count_room}} {{count_room > 1 ? $t('apartment.reservations.bedrooms') : $t('apartment.reservations.bedroom')}}</div>
                  <!-- <div>Gồm Ăn Sáng</div> -->
                </div>
              </div>
              <div class="col-xs-12">
                <div class="col-xs-12">
                  <hr>
                </div>
              </div>
            </div>
          </div>
          <div>
            <div class="col-xs-12">
              <div class="col-xs-12">
                <h2 class="page-header">
                  <i class="fa fa-map"></i> <strong>{{$t('project.operator_address')}}</strong>
                </h2>
              </div>
            </div>
            <div class="col-xs-12">
              <div class="col-xs-12">
                <small class="small-title"> <i class="fa fa-map-pin"></i> {{address}}</small>
              </div>
              <div class="col-xs-12">
                <hr>
              </div>
            </div>
          </div>
          <div>
            <div class="col-xs-12 no-padding">
              <div class="row">
              <div class="col-xs-6" style="border-right: 1px solid;">
                <div class="col-xs-12">
                  <div class="col-xs-12">
                    <h2 class="page-header">
                      <i class="fa fa-money"></i> <strong>{{$t('apartment.reservations.room_rate')}}</strong>
                    </h2>
                  </div>
                </div>
                <div class="col-xs-12">
                  <div class="col-xs-12">
                    <div class="col-xs-12">
                      Thuê Phòng
                      <span class="pull-right badge bg-orange">{{room_rate.fee}}</span>
                    </div>
                    <div class="col-xs-12">
                      Thuế VAT ({{room_rate.vat}}%)
                      <span class="pull-right badge bg-orange">{{room_rate.vat_fee}}</span>
                    </div>
                    <div class="col-xs-12">
                      Tổng Phí
                      <span class="pull-right badge bg-orange">{{room_rate.total}}</span>
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-xs-6">
                <div class="col-xs-12">
                  <div class="col-xs-12">
                    <h2 class="page-header">
                      <i class="fa fa-building"></i> <strong>{{$t('project.info')}}</strong>
                    </h2>
                  </div>
                </div>
                <div class="col-xs-12">
                  <div class="col-xs-12">
                    <div class="col-xs-12">
                      {{$t('project.project_name')}}
                      <span class="pull-right badge bg-info">{{project_name}}</span>
                    </div>
                    <div class="col-xs-12">
                      {{$t('project.operator_website')}}
                      <span class="pull-right badge bg-info">{{website}}</span>
                    </div>
                    <div class="col-xs-12">
                      {{$t('project.operator_telephone')}}
                      <span class="pull-right badge bg-info">{{mobile_phone}}</span>
                    </div>
                  </div>
                </div>
              </div>
              </div>
              <div class="col-xs-12">
                <div class="col-xs-12">
                  <hr>
                </div>
              </div>
            </div>
          </div>
          <div>
            <div class="col-xs-12">
              <div class="col-xs-12">
                <h2 class="page-header">
                  <i class="fa fa-list-ul"></i> <strong>{{$t('apartment.reservations.payment_installment')}}</strong>
                </h2>
              </div>
            </div>
            <div class="col-xs-12">
              <div class="row no-margin">
                <div class="col-xs-12 table-responsive">
                  <table class="table table-striped">
                    <thead>
                      <tr>
                        <th>{{$t('apartment.reservations.payment_service')}}</th>
                        <th>{{$t('apartment.reservations.payment_code')}}</th>
                        <th>{{$t('apartment.reservations.payment_date')}}</th>
                        <th>{{$t('apartment.reservations.payment_fee')}}</th>
                        <th>{{$t('apartment.reservations.payment_status')}}</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr v-for="(item, index) in booking_fee_details" :key="index">
                        <td>{{item.service}}</td>
                        <td>{{item.payment_code}}</td>
                        <td>{{item.payment_date}}</td>
                        <td><span class="badge bg-orange">{{item.fee}}</span></td>
                        <td>{{getFeeStatusName(item.status)}}</td>
                      </tr>
                    </tbody>
                  </table>
                </div>
                <!-- /.col -->
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="box-footer">
        <button
          type="button"
          class="btn btn-warning"
          @click="onReturn()"
        ><i class="fa fa-mail-reply"></i> Quay Về</button>
        <a class="btn btn-default"><i class="fa fa-mobile-phone"></i> Gọi Điện</a>
        <a class="btn btn-default"><i class="fa fa-envelope"></i> Email</a>
        <a class="btn btn-default"><i class="fa fa-print"></i> Print</a>
        <button
          type="button"
          class="btn btn-warning pull-right"
        >Hủy Đặt Phòng</button>
      </div>
    </div>
    <lte-core-alert v-for="snackbar in GET_SNACK_BAR" :key="snackbar.id" :item="snackbar"></lte-core-alert>
    <loading :active.sync="isLoading" :can-cancel="false" color="#1E90FF"></loading>
  </div>
</template>

<script>
import {
    mapGetters,
    mapActions
} from "vuex";
// import Confirm from "@/components/Confirm.vue"
import moment from "moment"
import LTECoreAlert from "@/components/LTESnackBar.vue"
import Loading from "vue-loading-overlay";
import utils from "@/lib/utils"
import PaymentStatusEnum from "@/enum/paymentStatusEnum";

export default {
  name: "LeaseBackBookingInfoView",
  data() {
    return {
      id: 0,
      isLoading: false,
      booking_code: "",
      apartment_code: "",
      checkin_datetime: "",
      checkout_datetime: "",
      duration: "",
      customer_full_name: "",
      customer_type: "",
      count_room: 0,
      address: "",
      project_name: "",
      website: "",
      mobile_phone: "",
      type: "",
      dob: null,
      age: 0,
      room_rate: {
        fee: 0,
        vat: 0,
        vat_fee: 0,
        total: 0
      }
    }
  },
  watch: {
    booking_fees: function() {
    },
    GET_BOOKING_DETAIL_DATA: function() {
      let data = this.GET_BOOKING_DETAIL_DATA
      // BOOKING CODE
      this.booking_code = data.apartment_booking_detail.booking_code
      // APARTMENT CODE
      this.apartment_code = data.apartment_booking_detail.apartment_code
      // CHECK IN DATE TIME
      this.checkin_datetime = utils.formatSqlDate(data.apartment_booking_detail.checkin_datetime, null, "DD/MM/YYYY", "")
      // CHECK OUT DATE TIME
      this.checkout_datetime = utils.formatSqlDate(data.apartment_booking_detail.checkout_datetime, null, "DD/MM/YYYY", "")
      // CUSTOMER FULL NAME
      this.customer_full_name = data.apartment_booking_detail.customer_last_name + ' ' + data.apartment_booking_detail.customer_first_name
      // AGE
      this.dob = data.apartment_booking_detail.dob
      this.age = data.apartment_booking_detail.dob ? moment().diff(data.apartment_booking_detail.dob, "years", false) : null
      // DURATION
      let duration = this.getDaysDiff(data.apartment_booking_detail.checkout_datetime, data.apartment_booking_detail.checkin_datetime)
      this.duration = duration
      // COUNT ROOM
      this.count_room = data.apartment_booking_detail.apartment_bedrooms ? data.apartment_booking_detail.apartment_bedrooms: 0
      // ADDRESS
      this.address = data.project_detail.address
      // PHONE
      this.mobile_phone = data.project_detail.phone
      // PROJECT NAME
      this.project_name = data.project_detail.project_name
      // WEBSITE
      this.website = data.project_detail.website
      // ROOM RATE
      this.room_rate.fee = this.formatNumber(data.service_booking_detail.room_rate)
      this.room_rate.vat = data.service_booking_detail.room_rate_vat
      this.room_rate.vat_fee = (data.service_booking_detail.room_rate*data.service_booking_detail.room_rate_vat)/100
      this.room_rate.total = this.formatNumber(data.service_booking_detail.room_rate + (data.service_booking_detail.room_rate*data.service_booking_detail.room_rate_vat)/100)
    }
  },
  computed: {
    ...mapGetters("bookingModule", {
      booking_fees: "BOOKING_FEE_LIST"
    }),
    ...mapGetters([
      "GET_SNACK_BAR",
      "GET_BOOKING_DETAIL_DATA"
    ]),
    dateViewOptions: function(){
      return sessionStorage.getItem('projectDateViewOptions')
    },
    booking_fee_details: function() {
      let booking_fee_details = []
      this.booking_fees.forEach(v => {
        let item = {
          service: v.service,
          payment_code: v.payment_code,
          payment_date: utils.formatSqlDate(v.payment_date, null, this.dateViewOptions),
          fee: this.formatNumber(v.fee),
          status: v.status
        }
        booking_fee_details.push(item)
      })
      return booking_fee_details
    }
  },
  methods: {
    ...mapActions("bookingModule", [
      "GET_BOOKING_FEE_LIST"
    ]),
    ...mapActions([
      "GET_BOOKING_DETAIL"
    ]),
    getFeeStatusName: function (status) {
      if (status == PaymentStatusEnum.PAID) {
        return this.$t('apartment.reservations.fee_status.paid')
      } else if (status == PaymentStatusEnum.CANCELLED) {
        return this.$t('apartment.reservations.fee_status.cancelled')
      }
      return this.$t('apartment.reservations.fee_status.open')
    },
    getDaysDiff: function(date2, date1, include_start=true){
      let date2_m = {
        day: moment(date2).date(),
        month: moment(date2).month(),
        year: moment(date2).year()
      }
      let date1_m = {
        day: moment(date1).date(),
        month: moment(date1).month(),
        year: moment(date1).year()
      }
      date2_m = moment([date2_m.year, date2_m.month, date2_m.day])
      date1_m = moment([date1_m.year, date1_m.month, date1_m.day])
      if (include_start){
        return date2_m.diff(date1_m, 'days') + 1
      }
      return date2_m.diff(date1_m, 'days')
    },
    formatNumber: function(n){
      return utils.formatNumber(n)
    },
    getBookingDetails: function(projectId) {
      if (parseInt(this.id) !== 0){
        this.isLoading = true
        this.GET_BOOKING_DETAIL({id: this.id}).then(
          function(res) {
            // Todo
            this.isLoading = false
          }.bind(this)
        ).catch(
          function(error) {
            this.isLoading = false
          }.bind(this)
        )
      }
    },
    getFeeDetails: function() {
      if (parseInt(this.id) !== 0){
        const data = {
          params: {
            apt_booking_id: this.id
          }
        }
        this.GET_BOOKING_FEE_LIST(data)
      }
    },
    onReturn: function() {
      this.$router.push({
        name: "ApartmentReservationList"
      })
    }
  },
  mounted() {
    this.id = parseInt(this.$route.params.id)
    this.getFeeDetails()
    this.getBookingDetails()
  },
  components: {
    loading: Loading,
    "lte-core-alert": LTECoreAlert
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.service-container {
  max-height: 400px;
  overflow: auto;
}

.section-header {
  margin: 10px 0 20px 0;
  padding-bottom: 9px;
  border-bottom: 1px solid #eee;
}

.page-header {
  margin: 10px 0 20px 0;
  font-size: 16px;
  border-bottom: none;
}

.small-title {
  color: #666;
  display: block;
  margin-top: 5px;
  font-size: 14px;
}

.hr {
  border-top: 1px solid #eee;
}

</style>



// WEBPACK FOOTER //
// src/views/Apartment/LeaseBackBookingInfoView.vue